var VehiclesBookingEventController = /** @class */ (function () {
    function VehiclesBookingEventController($scope, $element) {
        this.$scope = $scope;
        this.$element = $element;
        this.event = this.$scope.event;
        this.position = this.getPosition(this.event);
        this.watch();
    }
    VehiclesBookingEventController.prototype.watch = function () {
        var _this = this;
        //Update postion when event was changed
        this.$scope.$watch("event", function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.event = newValue;
                _this.position = _this.getPosition(_this.event);
                _this.updatePosition(_this.position);
            }
        });
    };
    /**
     * Get postion from booking
     * @param {IVehicleBooking} event
     */
    VehiclesBookingEventController.prototype.getPosition = function (event) {
        var startTime = this.getDuration(event.StartTime), endTime = this.getDuration(event.EndTime), top = (startTime / 24) * 100, height = (endTime / 24) * 100 - top;
        //Set min height
        if (height <= 25)
            height = 25;
        return {
            top: top,
            height: height
        };
    };
    /**
     * Get duration from time
     * @param {string} time
     * @returns {number}
     */
    VehiclesBookingEventController.prototype.getDuration = function (time) {
        if (!time)
            return 0;
        var res = time.split(":");
        return parseInt(res[0]) + parseInt(res[1]) / 60;
    };
    /**
     * Update position of element
     * @param position
     */
    VehiclesBookingEventController.prototype.updatePosition = function (position) {
        this.$element.css({
            top: position.top + '%',
            height: position.height + '%'
        });
    };
    VehiclesBookingEventController.$inject = ['$scope', '$element'];
    return VehiclesBookingEventController;
}());
angular.module('shared').directive('vehicleBookingEvent', function () {
    return {
        restrict: 'E',
        controller: VehiclesBookingEventController,
        controllerAs: 'vm',
        templateUrl: 'js/internal/vehiclebookings/directives/vehicle-booking-event/vehicle-booking-event.html',
        scope: {
            event: "="
        },
        replace: true
    };
});
